import MCPlot from './mc/MCPlot';
import WorkbenchTable from './workbench/WorkbenchTable';
import { WorkbenchPlotsSection } from './workbench/WorkbenchPlotsContainer';
import AnalysisContainer from '../core/AnalysisContainer';
import { TabContainer } from '../core/TabContainer';
import { ANALYSIS_STATUS } from '@/consts';
import { useAnalysisTypes } from '@/stores/analysisStatusStore';
import SensitivityPlot from './sensitivity/SensitivityPlot';
import { PlotSyncProvider } from '../providers/PlotSyncProvider';

export const SensitivityAnalysisSection = () => {
  const analysisTypes = useAnalysisTypes();
  const isMCAnalysisAvailable = analysisTypes?.mc?.status === (ANALYSIS_STATUS.succeeded || ANALYSIS_STATUS.pending);
  const isSensitivityAvailable =
    analysisTypes?.sensitivity?.status === (ANALYSIS_STATUS.succeeded || ANALYSIS_STATUS.pending);

  const sensitivityTabs = [
    ...(isSensitivityAvailable
      ? [
          {
            id: 'lca',
            label: 'Emissions',
            content: () => <SensitivityPlot type="lca" key={'lca'} />,
          },
          {
            id: 'tea',
            label: 'Costs',
            content: () => <SensitivityPlot type="tea" key={'tea'} />,
          },
        ]
      : []),
    ...(isMCAnalysisAvailable
      ? [
          {
            id: 'mc',
            label: 'Monte Carlo',
            content: () => <MCPlot />,
          },
        ]
      : []),
    {
      id: 'workbench',
      label: 'Workbench',
      content: () => (
        <>
          <WorkbenchTable />
          <WorkbenchPlotsSection />
        </>
      ),
    },
  ];

  return (
    <PlotSyncProvider paramKeys={['nodeId', 'levelizeBy', 'levelizeUnit']}>
      <AnalysisContainer title="Sensitivity Analysis">
        <TabContainer tabs={sensitivityTabs} defaultTab={sensitivityTabs[0]?.id} />
      </AnalysisContainer>
    </PlotSyncProvider>
  );
};
